// Não enviar o fragmento ao monitoramento nem mantê-lo no histórico visível.
let resetToken = null;
function captureResetLink() {
  if (!window.location.hash.startsWith('#reset-password=')) return;
  resetToken = new URLSearchParams(window.location.hash.slice(1)).get('reset-password') || '';
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  window.dispatchEvent(new CustomEvent('rotaflex-password-reset-link'));
}
if (typeof window !== 'undefined') {
  captureResetLink();
  // Também funciona quando o aplicativo já está aberto na mesma aba.
  window.addEventListener('hashchange', captureResetLink);
}
export const getResetToken = () => resetToken;
export const clearResetToken = () => { resetToken = null; };
